;(function () {
  'use strict'

  angular.module('contrast.features').constant('AGENT_FEATURE', {
    APP_ASSESS_EXCLUSIONS: 'app-assessment-exclusions',
    APP_PROTECT_EXCLUSIONS: 'app-protection-exclusions',
    SYSLOG: 'syslog',
    VIRTUAL_PATCHES: 'virtual-patches',
    PROTECTION: 'protection',
    ASSESS: 'assess',
    LOG_ENHANCERS: 'log-enhancers'
  })
})()
